import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { editMutations } from './types';

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		VyrobekndOzn: [],
		S2MjId: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit: {
		ZaznamId: null as number | null,
		PsndnahradaId: null as number | null,
		ZaznamIdMap: null as number | null,
		VyrobekndOznPseudo: null as string | null,
		NdNrPseudo: null as string | null,
		Text: null as string | null,
		S2MjId: null as number | null,
		Saga2Prp: null as boolean | null,
		SdaPrp: null as boolean | null,
		VyrobekndOzn: null as string | null,
		NdNr: null as string | null,
		VydejMjKoef: null as number | null,
		VstupDatZahlavi: null as string | null,
		VstupDatMap: null as string | null,
		VstupPracIdMap: null as number | null,
		EditDatMap: null as string | null,
		EditPracIdMap: null as number | null,
		EditPracIdMapText: null as string | null,
		NeorigNdPrp: null as boolean | null,
		S2MjText: null as number | null,
		TextPseudo: null as string | null,
		PseudoPomer: null as string | null,
	},
	localState: {},
	extraActions: {},
	extraMutations: {
		[editMutations.PSEUDO_NAHRADY_ND_SKLAD_SELECT_MAPPER](state, { data }) {
			state.edit.NdNr = data.ndnr;
			state.edit.Text = data.text;
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
